module.exports = __webpack_public_path__ + "img/user-helmet-safety.79a9f5f5.svg";